// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import infoCircleIcon from "@/assets/icons/info-circle.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type InfoCircleIconProps = Omit<IconProps, "name">;

export function InfoCircleIcon(props: InfoCircleIconProps): React.ReactNode {
  return <Icon name={infoCircleIcon} {...props} />;
}
